module.exports = __webpack_public_path__ + "img/wa-d.d9d35252.png";